<template>
  <div class="dg__link aui-inline">
    <a v-if="url" :href="url" class="link no-underline" target="_blank">
      <slot></slot>
    </a>
    <span v-else>-</span>
  </div>
</template>

<script>
export default {
  name: "dg-link",
  props: {
    href: String,
    fileName: String,
    down: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      url: "",
    };
  },
  watch: {
    href:{
      handler() {
        this.trans();
      },
      immediate: true,
    },
   
  },
  methods: {
    trans() {
      console.log('this.href',this.href);
      if (this.href) {
        if (this.down) {
          const fileExtension = this.href.split(".").pop();
          this.url = `${this.href}?attname=${this.fileName}.${fileExtension}`;
          console.log(this.url);
        } else {
          this.url = this.href;
        }
      }
    },
  },
  created() {
    this.trans();
  },
};
</script>

<style lang="less" scoped>
@import '~@/assets/css/var.less';
.dg__link {
  width: 120px;

  a {
    color: @theme;
  }
}
</style>
 <style>.inline {
    display: inline
}
.no-underline {
    text-decoration: none
}</style>